import { render, staticRenderFns } from "./CloseCross.vue?vue&type=template&id=41165a01&scoped=true&"
import script from "./CloseCross.vue?vue&type=script&lang=js&"
export * from "./CloseCross.vue?vue&type=script&lang=js&"
import style0 from "./CloseCross.vue?vue&type=style&index=0&id=41165a01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41165a01",
  null
  
)

export default component.exports